import {CreateBundleMultiStepForm} from "../multi-step-form";

export function CreateBundleMultiStepFormWrapper() {
  return <CreateBundleMultiStepForm />;
}
